import { use_slice_user } from '@/hooks/store/use_slices';
import { RootState } from '@/state/store';
import { EAuthProvider } from '@shared/dto/+user/auth/EAuthProvider';
import { useSelector } from 'react-redux';

export function is_unlink_disabled(account_id: string): boolean {
  const { is_password_set } = use_slice_user(['is_password_set']);

  const slice_user = useSelector((state: RootState) => state.slice_user);

  const linked_accounts = Object.values(EAuthProvider).filter(config => {
    return config in slice_user && slice_user[config as keyof typeof slice_user];
  }).length;

  return !account_id.is_blank() && !is_password_set && linked_accounts === 1;
}
